import { SUPPORTED_ATTRIBUTES } from '../constants/supported-attributes';

const removeUnsupportedAttributes = (element) => {
  const attributes = Object.values(element.attributes).map((value) => value.name);

  attributes.forEach((attr) => {
    if (SUPPORTED_ATTRIBUTES.includes(attr)) return;
    element.removeAttribute(attr);
  });
};

export default removeUnsupportedAttributes;
